exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.floorStyle .btn-width__100 {\n  width: 100%;\n}\n.floorStyle .del-or-add-nav {\n  margin-top: 20px;\n}\n.floorStyle .del-or-add-nav i {\n    cursor: pointer;\n}\n.floorStyle .img-pendant__uploader {\n  width: 150px;\n  border: 1px dashed #ddd;\n  padding: 10px;\n  cursor: pointer;\n}\n.floorStyle .goods-name {\n  line-height: 22px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-9bcec604","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/pc/homePage/components/plugins/floor/style.vue
// module id = 1649
// module chunks = 0